/** saves Cards List
@payload { Array }
*/
export const SAVE_CARDS_LIST = (state, payload) => {
	state.cardsList = payload.map(card => {
		return {
			...card,
			friendlyName: card.additionalInfoCardView.friendlyName ? card.additionalInfoCardView.friendlyName : ''
		}
	})
}

/** saves Last Transfers List
@payload { Array }
*/
export const SAVE_LAST_TRANSFERS = (state, payload) => {
	state.lastTransfersList = payload.data.transferBetweenPrepaidCardsList
}

/** saves Favorites List
@payload { Array }
*/
export const SAVE_FAVORITES_LIST = (state, { pageNumber, data }) => {
	state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)
	state.favoritesHasMore = state.favoritesList.length < data.total
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.cardsList = []
	state.lastTransfersList = []
	state.favoritesList = []
	state.favoritesHasMore = false
}
